import axios from 'axios';
import psProfileFavorites from '../psProfileFavorites/psProfileFavorites';
import psProfileContacts from '../psProfileContacts/psProfileContacts';
import psProfileTools from '../psProfileTools/psProfileTools';

export default class psProfile {
    constructor() {
        const container = document.getElementById('profile-section');

        if (!container) {
            this._initLoginOnly();
            return;
        }

        this.container = container;

        this._init();
    }

    _initLoginOnly() {
        const login = document.getElementById('ps-login-form');

        if (!login) {
            return;
        }

        // Event för att öppna loginmeny
        document.body.addEventListener('click', event => this._menuToggleHandler(event.target, true));

        login.addEventListener('submit', event => {
            event.preventDefault();
            const form = login.querySelector('form');
            const errorElement = login.querySelector('.ps-login__error');
            errorElement.toggleAttribute('hidden', true);

            var formData = new FormData();
            formData.append("UserName", $("#CurrentProfile_UserName").val())
            formData.append("Password", $("#CurrentProfile_Password").val())

            setTimeout(async () => {
                try {
                    await axios.post(form.action, formData);
                    window.location.reload();
                } catch (error) {
                    errorElement.toggleAttribute('hidden', false);
                }
            }, 700);
        });

        const mediaRefreshFn = (mqle) => {
            login.toggleAttribute('hidden', mqle.matches);
            document.querySelectorAll('[aria-controls="ps-login-form"]').forEach(btn => {
                btn.setAttribute('aria-expanded', !login.hasAttribute('hidden'));
            });
        };

        // Sätter synlighet på loginformulär vid övergångar mellan medium/desktop
        // Matcha detta mot $device-medium-max
        const mql = window.matchMedia('(max-width: 1024px)');
        mql.addEventListener('change', mediaRefreshFn);
        document.addEventListener('DOMContentLoaded', () => mediaRefreshFn(mql), { once: true });
    }

    _init() {
        // Event för att öppna profilmeny
        document.body.addEventListener('click', event => this._menuToggleHandler(event.target, false));

        const minimizeButton = document.getElementById('minimize-profile');
        minimizeButton && minimizeButton.addEventListener('click', () => {
            const content = document.getElementById(minimizeButton.getAttribute('aria-controls'));

            if (!content) {
                return;
            }

            content.toggleAttribute('hidden', true);
            minimizeButton.setAttribute('aria-expanded', false);

            for (const btn of document.querySelectorAll('[data-show-box]')) {
                btn.setAttribute('aria-expanded', false);
            }
        });

        // Mobile expanding lists
        this.container.addEventListener('click', event => {
            const btn = event.target;

            if (!btn.classList.contains('profile__mobile-expand')) {
                return;
            }

            const content = document.getElementById(btn.getAttribute('aria-controls'));

            if (!content) {
                return;
            }

            const state = !content.classList.toggle('profile__mobile-hide');
            btn.setAttribute('aria-expanded', state);
            btn.classList.toggle('profile__mobile-expand--modifier', state);
        });

        // Flip-box flipping
        document.getElementById('main-content').addEventListener('click', event => {

            if (!event.target.classList.contains('flip-box-flipper')) {
                return;
            }

            const flipBox = event.target.closest('.flip-box');

            if (!flipBox) {
                return;
            }

            const frontBox = flipBox.querySelector('.flip-box-front');
            const backBox = flipBox.querySelector('.flip-box-back');
            const toggleButton = backBox.querySelector('button');

            flipBox.classList.toggle('flip-box__active');

            if (flipBox.classList.contains('flip-box__active')) {

                // Back is visible
                frontBox.setAttribute('inert', '');
                backBox.removeAttribute('inert');

                // Focus close button
                toggleButton.focus();

            } else {

                // Back is hidden
                backBox.setAttribute('inert', '');
                frontBox.removeAttribute('inert');

                // Focus the element that opened the box
                event.target.focus();
            }
        });

        new psProfileFavorites();
        new psProfileTools();
        new psProfileContacts();
    }

    _menuToggleHandler(btn, login) {
        if (!(btn.hasAttribute('data-show-box') || (login && btn.classList.contains('profile__not-loggedin')))) {
            return;
        }

        const id = btn.getAttribute('aria-controls');
        const content = document.getElementById(id);

        if (!content) {
            return;
        }

        const state = !content.toggleAttribute('hidden');

        for (const b of document.querySelectorAll(`[aria-controls="${id}"]`)) {
            b.setAttribute('aria-expanded', state);
        }

        if (state) {
            content.classList.remove("profile__hide-mobile-default");
            content.classList.remove("ps-login__hide-mobile-default");
            content.focus({ preventScroll: true });
        }

        if (login === true) {
            const loginIcon = document.querySelector('.ps-login__user-icon:not(.ps-login__user-icon-mobile)');
            if (loginIcon && loginIcon.getAttribute('aria-controls') === 'ps-login-form') {
                const label = state ?
                    (document.documentElement.lang == 'sv' ? "D&oring;lj login" : "Hide login") :
                    (document.documentElement.lang == 'sv' ? "Visa login" : "Show login");
                loginIcon.setAttribute('aria-label', this._decodeHtmlText(label));
            }
        }
    }

    _decodeHtmlText(text) {
        const span = document.createElement('span');
        span.innerHTML = text;
        return span.innerText;
    }
}
